import { ShowCaseActionType } from "./enums/showCaseActionType";

export class CreditViewData {

    public Summa: string = "";

    public Period: string = "";

    public Percent: string = "";

    /**
     * Тип действия элемента витрины.
     */
    public ActionType: ShowCaseActionType = ShowCaseActionType.None;

    /**
     * URL для действия элемента витрины.
     */
    public ActionLink: string = "";

    public Description: string = "";

    constructor(src: any) {
        this.Summa = src.summa ?? '';
        this.Period = src.period ?? '';
        this.Percent = src.percent ?? '';
        this.ActionLink = src.actionLink ?? '';
        this.ActionType = (src.actionType as ShowCaseActionType) ?? ShowCaseActionType.None;
        this.Description = src.description ?? '';
    }
}